module.exports = __webpack_public_path__ + "static/img/weibo.f57d258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weibo.png
// module id = ocd5
// module chunks = 1